import { Question } from "../types";
import { getOptionLetter } from "./optionLetters";

export type EmqGroupReviewRow = {
  questionId: number;
  partOrder: number;
  selectedLetter: string;
  correctLetter: string;
  isCorrect: boolean;
  skipped: boolean;
  explanation: string;
  explanationImageUrl: string;
};

export function partOrderToLetter(partOrder: number): string {
  if (!Number.isFinite(partOrder) || partOrder < 1) {
    return "?";
  }
  let n = Math.floor(partOrder);
  let label = "";
  while (n > 0) {
    n -= 1;
    label = String.fromCharCode(65 + (n % 26)) + label;
    n = Math.floor(n / 26);
  }
  return label;
}

export function buildEmqGroupReviewRows(
  siblings: Question[],
): EmqGroupReviewRow[] {
  return siblings.map((sibling) => {
    const selected = sibling.answerOptions.find((ao) => ao.selected);
    const correct = sibling.answerOptions.find((ao) => ao.isCorrect);
    const selectedIndex = selected
      ? sibling.answerOptions.findIndex((ao) => ao.id === selected.id)
      : -1;
    const correctIndex = correct
      ? sibling.answerOptions.findIndex((ao) => ao.id === correct.id)
      : -1;

    return {
      questionId: sibling.id,
      partOrder: sibling.emqPart?.partOrder ?? 0,
      selectedLetter: selected
        ? getOptionLetter(selected, selectedIndex)
        : "—",
      correctLetter: correct ? getOptionLetter(correct, correctIndex) : "?",
      isCorrect: !!selected?.isCorrect,
      skipped: !!sibling.skipped,
      explanation: sibling.explanation,
      explanationImageUrl: sibling.explanationImageUrl,
    };
  });
}

/** Prefer a known focus id when present; otherwise the last part. */
export function defaultEmqReviewPartId(
  rows: EmqGroupReviewRow[],
  preferredQuestionId?: number | null,
): number | null {
  if (rows.length === 0) return null;
  if (
    preferredQuestionId != null &&
    rows.some((row) => row.questionId === preferredQuestionId)
  ) {
    return preferredQuestionId;
  }
  return rows[rows.length - 1].questionId;
}

export function countEmqGroupCorrect(rows: EmqGroupReviewRow[]): number {
  return rows.filter((row) => !row.skipped && row.isCorrect).length;
}
